module.exports = __webpack_public_path__ + "img/TeamComic_046.61c19f50.png";